/* eslint-disable camelcase */
import {unlayerFormFields} from './unlayerFormFields';
import {unlayerDefaultFormActions} from './unlayerDefaultFormActions';

export const unlayerTools = {
  form: {
    properties: {
      fields: unlayerFormFields,
      action: {
        editor: {
          data: {
            actions: unlayerDefaultFormActions,
            allowCustomUrl: true,
          },
        },
      },
    },
  },
};
